module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('div', {
    staticClass: "con",
    attrs: {
      "id": "articleMain"
    }
  }, [(_vm.con.length == 0) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.bodydata)
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.con), function(item, i) {
    return [(item.type == 'text') ? [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.con)
      }
    })] : _vm._e(), _vm._v(" "), (item.type == 'img') ? [_c('div', {
      staticClass: "img-container",
      class: item.mode,
      style: (item.dataHeight ? 'height:' + item.dataHeight : ''),
      on: {
        "click": function($event) {
          _vm.showImg(item, $event)
        }
      }
    }, [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.mode === 'on'),
        expression: "item.mode === 'on'"
      }],
      staticClass: "imgs",
      class: item.mode,
      attrs: {
        "src": _vm.getImgSrc(item.src)
      },
      on: {
        "load": function($event) {
          _vm.imgLoaded(item)
        }
      }
    })])], 1), _vm._v(" "), (item.tips) ? _c('span', {
      staticClass: "tips"
    }, [_vm._v(_vm._s(item.tips))]) : _vm._e()] : _vm._e(), _vm._v(" "), (item.type == 'gif') ? [_c('div', {
      staticClass: "img-container",
      class: item.mode,
      style: (item.dataHeight ? 'height:' + item.dataHeight : ''),
      on: {
        "click": function($event) {
          _vm.showGifImg(item, $event)
        }
      }
    }, [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.mode === 'on' || item.mode === 'gifLoading' || item.mode === 'gif'),
        expression: "item.mode === 'on' || item.mode === 'gifLoading' || item.mode === 'gif'"
      }],
      staticClass: "data-gif-src",
      class: item.mode,
      attrs: {
        "src": _vm.getImgSrc(item.src)
      },
      on: {
        "load": function($event) {
          _vm.gifLoaded(item)
        }
      }
    })]), _vm._v(" "), (item.mode !== 'gif') ? _c('div', {
      staticClass: "media-loader"
    }) : _vm._e(), _vm._v(" "), (item.mode === 'on') ? _c('div', {
      staticClass: "media-holder"
    }) : _vm._e(), _vm._v(" "), (item.mode === 'on') ? _c('div', {
      staticClass: "media-label"
    }) : _vm._e()], 1), _vm._v(" "), (item.tips) ? _c('span', {
      staticClass: "tips"
    }, [_vm._v(_vm._s(item.tips))]) : _vm._e()] : _vm._e(), _vm._v(" "), (item.type == 'music') ? [_c('div', {
      staticClass: "audio"
    }, [_c('audio', {
      attrs: {
        "preload": "off",
        "src": _vm.getImgSrc(item.src)
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
      staticClass: "main playing"
    }, [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.artist))]), _vm._v(" "), (item.pause) ? _c('a', {
      staticClass: "play",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.audioPlay(item, $event)
        }
      }
    }) : _c('a', {
      staticClass: "pause",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.audioPause(item)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "progress"
    })])] : _vm._e(), _vm._v(" "), (item.type == 'video') ? [(_vm.checkMode(item)) ? _c('section', {
      staticClass: "video"
    }, [_c('video', {
      style: ('background:url(' + _vm.getImgSrc(item.thumb) + ') top center no-repeat rgba(0,0,0,0.7);background-size: cover;'),
      attrs: {
        "src": _vm.getImgSrc(item.src),
        "controls": "controls"
      },
      on: {
        "play": function($event) {
          _vm.videoPlay()
        }
      }
    })]) : [_c('div', {
      staticClass: "mask"
    }), _vm._v(" "), (item.thumb) ? _c('div', {
      staticClass: "media-container media-container-video",
      style: ({
        'backgroundImage': 'url(' + _vm.getImgSrc(item.thumb) + ')',
        'height': _vm.video_height + 'px'
      }),
      on: {
        "click": function($event) {
          _vm.videoPlay(item.src)
        }
      }
    }, [_c('div', {
      staticClass: "media-holder media-holder-video"
    })]) : _c('div', {
      staticClass: "media-container media-container-video",
      style: ({
        'height': _vm.video_height + 'px'
      }),
      on: {
        "click": function($event) {
          _vm.videoPlay(item.src)
        }
      }
    }, [_c('div', {
      staticClass: "media-holder media-holder-video"
    })]), _vm._v(" "), (item.tips) ? _c('span', {
      staticClass: "tips_v"
    }, [_vm._v(_vm._s(item.tips))]) : _vm._e()]] : _vm._e(), _vm._v(" "), (item.type == 'subtitle') ? [(item.tagName === 'H2') ? _c('h2', [_c('span', {
      staticClass: "border"
    }), _vm._v(_vm._s(item.con))]) : _c('h3', [_c('span', {
      staticClass: "border"
    }), _vm._v(_vm._s(item.con))])] : _vm._e(), _vm._v(" "), (item.type == 'votes') ? [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ready),
        expression: "item.ready"
      }],
      staticClass: "vote_box"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      class: item.voteType
    }, [(!item.voted) ? [_c('dl', [_c('dt', [_vm._v("\n                                    " + _vm._s(item.title) + "\n                                    "), _c('span', [(item.voteType === 'checkbox') ? [_vm._v("\n                        (allow " + _vm._s(item.max_vote) + " options)\n                      ")] : _vm._e()], 2)]), _vm._v(" "), _vm._l((item.options), function(option, index) {
      return [(option.sel) ? _c('dd', {
        staticClass: "checked",
        on: {
          "click": function($event) {
            _vm.optionSel(option, index, item)
          }
        }
      }, [_c('span', {
        staticClass: "tag"
      }), _vm._v("\n                                        " + _vm._s(option.title) + "\n                                    ")]) : _vm._e(), _vm._v(" "), (!option.sel) ? _c('dd', {
        on: {
          "click": function($event) {
            _vm.optionSel(option, index, item)
          }
        }
      }, [_c('span', {
        staticClass: "tag"
      }), _vm._v("\n                                        " + _vm._s(option.title) + "\n                                    ")]) : _vm._e()]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [(item.selCounter > 0) ? _c('a', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.optionSub(item)
        }
      }
    }, [_vm._v("Submit")]) : _c('a', {
      staticClass: "btn btn_dis"
    }, [_vm._v("Submit")])])] : _vm._e(), _vm._v(" "), (item.voted) ? [_c('dl', {
      staticClass: "re"
    }, [_c('dt', [_vm._v("\n                                    " + _vm._s(item.title) + "\n                                    "), _c('span', [(item.voteType === 'checkbox') ? [_vm._v("\n                        (allow " + _vm._s(item.max_vote) + " options)\n                      ")] : _vm._e()], 2)]), _vm._v(" "), _vm._l((item.options), function(option, index) {
      return [_c('dd', [_c('h3', [_vm._v("\n                                            " + _vm._s(option.title) + " "), (option.voted) ? _c('em', [_vm._v("voted")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.stat) + "%")])]), _vm._v(" "), _c('div', {
        staticClass: "rank"
      }, [_c('div', {
        staticClass: "bar",
        class: option.voted ? 'voted' : '',
        style: ({
          width: option.stat + '%'
        })
      })])])]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [(item.selCounter > 0) ? _c('p', [_vm._v("Thanks for voting")]) : _c('p', [_vm._v("Voting is over")])])] : _vm._e()], 2)])] : _vm._e()]
  })], 2), _vm._v(" "), [(!_vm.afhao || _vm.afhao.length === 0 || JSON.stringify(_vm.afhao) === '{}') ? _c('div', {
    staticClass: "declare"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "afhaoBottom clearfix"
  }, [_c('p', {
    staticClass: "afhaoAbout"
  }, [_c('a', {
    attrs: {
      "href": _vm.afhao.intro_schema
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/afhao_about.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('AboutUserPosts')))])])]), _vm._v(" "), _c('p', {
    staticClass: "afhaoReport",
    on: {
      "click": function($event) {
        _vm.afhaoReport()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/alert.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Report')))])])])]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('span', [_vm._v("Vote")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://api.allfootballapp.com/about/copyright"
    }
  }, [_vm._v("Copyright Declaration")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c07b198","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/articleCon.vue
// module id = 740
// module chunks = 1